define.alias("shared/components/shared/post/secondary/high-performer/wrapper", "preview-grid/components/shared/post/secondary/high-performer/wrapper");